import React from 'react';
import { inject, observer } from 'mobx-react';
import { Grid } from '@mantine/core';
import { IconFolders } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import WrappedPrescriptionHistoryTable from '../Table/PrescriptionHistory.tsx';
import ClinicalNotesPanel from '../Widget/ClinicalNotesPanel.tsx';
import { patientStore } from '../../../global/Store/Store.ts';
import DocumentsTable from '../Table/DocumentsTable.tsx';
import Notes from '../Widget/Notes.tsx';
import PatientDataBox from '../Widget/PatientDataBox.tsx';
import WrappedLifeEventsTable from '../Table/LifeEventsTable.tsx';
import CollapsibleSection from '../Widget/CollapsibleSection.tsx';

const MedicalInformation: React.FC = inject()(
  observer(() => {
    const { t } = useTranslation();
    return (
      <Grid gutter="lg">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <PatientDataBox />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Notes />
        </Grid.Col>
        <Grid.Col span={12}>
          <CollapsibleSection
            title={t('hcpMedicalInformation.historySectionTitle')}
            subtitle={t('hcpMedicalInformation.historySectionSummary')}
            icon={<IconFolders size={24} />}
            showLabel={t('hcpMedicalInformation.show')}
            hideLabel={t('hcpMedicalInformation.hide')}
            storageKey="hcp_medical_information_history_expanded"
          >
            <Grid gutter="lg">
              <Grid.Col span={12}>
                <WrappedPrescriptionHistoryTable />
              </Grid.Col>
              <Grid.Col span={12}>
                <ClinicalNotesPanel
                  patientId={patientStore?.patientId}
                  patientName={patientStore?.name}
                  patientDateOfBirth={patientStore?.birthDate}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <DocumentsTable />
              </Grid.Col>
              <Grid.Col span={12}>
                <WrappedLifeEventsTable />
              </Grid.Col>
            </Grid>
          </CollapsibleSection>
        </Grid.Col>
      </Grid>
    );
  }),
);

export default MedicalInformation;
